
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/warehouseTransfer",
      function () {
        return require("private-next-pages/warehouseTransfer/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/warehouseTransfer"])
      });
    }
  